import React, { FC, useContext } from "react";

import { Link } from "capitalrx-components-2.0/lib/general";
import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import { LoginButton } from "@/components";
import { ThemeSelectorContext } from "@/context";
import { getThemeURL, isPrime } from "@/utils";

import styles from "./HeaderActionBar.module.scss";

const RESPONSIVE_LAYOUT = {
  spacing: {
    desktop: "medium",
    mobile: "small",
  },
};

export const HeaderActionBar: FC = () => {
  const { banner_gradient, logo, header_text_color } = useContext(ThemeSelectorContext);

  const { spacing } = useResponsive(RESPONSIVE_LAYOUT);
  const showHeading = spacing === "medium";

  return (
    <Grid
      className={styles.HeaderActionBarContainer}
      style={{ "--banner-gradient": banner_gradient } as React.CSSProperties}
    >
      <Grid.Span columns={4}>
        <Stack alignment="left">
          <>
            {typeof logo.url === "string" ? (
              <img src={logo.url} style={{ height: logo.height, width: logo.width }} />
            ) : (
              React.createElement(logo.url as React.ComponentType<React.SVGProps<SVGSVGElement>>, {
                style: { height: logo.height, width: logo.width },
              })
            )}
          </>
        </Stack>
      </Grid.Span>
      <Grid.Span columns={4}>
        <Stack alignment="center">
          {showHeading && (
            <Link to={getThemeURL("HOME")} style={{ textDecoration: "none" }}>
              <Heading style={{ color: header_text_color }}>Health Care Portal</Heading>
            </Link>
          )}
        </Stack>
      </Grid.Span>
      <Grid.Span columns={4}>
        <Stack alignment="right">
          {!isPrime && <LoginButton />}
        </Stack>
      </Grid.Span>
    </Grid>
  );
};
